import React, { useState } from "react"

export const routeTypes = {
    admin: "admin",
    retail: "retail",
    workstation: "workstation",
    customer: "customer",
    member: "member",
    public: "public",
    driver: "driver",
}

export function useSystemRoutes(type = '') {

    const [routeType, setRouteType] = useState(type)

    const _routes = {
        admin: "admin/",
        retail: "retail/",
        workstation: "workstation/",
        customer: "customer/",
        member: "member/",
        driver: "driver/"
    }

    const getRoute = (path = '') => {
        if (routeType === routeTypes.admin) {
            return `/${_routes.admin}${path}`
        }

        if (routeType === routeTypes.retail) {
            return `/${_routes.retail}${path}`
        }

        if (routeType === routeTypes.workstation) {
            return `/${_routes.workstation}${path}`
        }

        if (routeType === routeTypes.customer) {
            return `/${_routes.customer}${path}`
        }

        if (routeType === routeTypes.member) {
            return `/${_routes.member}${path}`
        }

        if (routeType === routeTypes.driver) {
            return `/${_routes.driver}${path}`
        }


        return "";
    }

    return { _routes, getRoute }
}